<template>
    <div>
        <div class="btn-caption">
            <button @click.prevent="showStripe" class="waves-effect waves-light btn-large">
                <span class="regular_price brand-font">{{ strikePriceLabel }}</span>
                &nbsp;
                <span class="sale_price">{{ priceLabel }}<sub><!--{{ this.offer.currency}}--><span v-if="this.offer.cycle">{{ this.offer.cycle }}</span></sub></span>
            </button>
            <span>{{ this.offer.price_caption }}</span>
        </div>
        <div class="legal center">{{ this.offer.terms }}</div>
    </div>
</template>

<style scoped>
    .regular_price {
        text-decoration: line-through;
        color: #cccccc;
        font-size: 1.5em;

    }

    .sale_price{
        font-weight: lighter;
        font-size: 1em;
    }

    .sale_price sub {
        bottom: +0.0em;
        font-size: 0.5em;
        text-transform: lowercase;
    }
</style>

<script>
  export default {
    name: 'purchase',
    props: ['offer'],
    data: function () {
      return {stripeHandler: null}
    },
    methods: {
      showStripe: function (event) {

        VueApp.$nprogress.start();

        this.stripeHandler.open({
          name: STRIPE_COMPANY,
          amount: this.offer.price * this.offer.coef,
          currency: this.offer.currency,
          description: this.offer.name,

          //custom
          billingAddress: true,
          shippingAddress: false,
          allowRememberMe: false,
        });
      }
    },

    computed: {
      priceLabel: function () {
        return this.offer.symbol + this.offer.price;
      },
      strikePriceLabel: function () {
        return this.offer.symbol + this.offer.strike_price;
      }
    },

    mounted: function () {
      var offer = this.offer;

      this.stripeHandler = StripeCheckout.configure({
        key: this.offer.stripe_public_key,
        image: STRIPE_LOGO,
        locale: 'auto',

        opened: function () {
          //console.log("Form opened");
        },
        closed: function () {
          VueApp.$nprogress.done();
        },

        token: function (token) {
          VueApp.$nprogress.start();
          token.event = 'stripeToken';
          token.offer = offer.key;
          broadcast(token);
        }.bind(offer)
      });
    }
  }
</script>